module.exports = __webpack_public_path__ + "static/media/zero-feedback.96247751.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/zero-feedback.png
// module id = 1229
// module chunks = 0